(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaronya-commissions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ap-art-compare')) {
  customElements.define('ap-art-compare', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      if (!input || this.bound) return;
      this.bound = true;
      input.addEventListener('input', () => this.style.setProperty('--reveal', input.value + '%'));
    }
  });
}
if (!customElements.get('ap-art-formats')) {
  customElements.define('ap-art-formats', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-format]').forEach(link => {
        link.addEventListener('click', () => {
          const select = this.closest('.ap-commission').querySelector('#ap-commission-format');
          if (select) select.value = link.dataset.format;
        });
      });
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaronya-showroom"] && !Shopify.designMode) return;
  try {
    

(function(){
function init(root){if(root.dataset.initialized)return;root.dataset.initialized='true';root.dataset.view='collections';const filters=[...root.querySelectorAll('[data-room-filter]')];const filterRooms=value=>{filters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.roomFilter===value)));root.querySelectorAll('[data-room-family]').forEach(card=>card.hidden=value!=='all'&&card.dataset.roomFamily!==value)};filters.forEach(b=>b.addEventListener('click',()=>filterRooms(b.dataset.roomFilter)));const tabs=[...root.querySelectorAll('[data-room-tab]')];const select=(id,focus=false,update=true)=>{if(!tabs.some(t=>t.dataset.roomTab===id))return;root.dataset.view='room';root.querySelector('[data-current-collection]').textContent=tabs.find(t=>t.dataset.roomTab===id).dataset.collectionTitle;if(update)history.pushState(null,'','#'+id);tabs.forEach(t=>{const on=t.dataset.roomTab===id;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;if(on&&focus)t.focus()});root.querySelectorAll('.ap-sr-panel').forEach(p=>p.hidden=p.id!=='ap-panel-'+id)};const fromHash=()=>{const id=location.hash.slice(1);if(tabs.some(t=>t.dataset.roomTab===id))select(id,false,false);else root.dataset.view='collections'};fromHash();addEventListener('hashchange',fromHash);addEventListener('popstate',fromHash);root.querySelectorAll('[data-collection]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();select(a.dataset.collection);root.querySelector('.ap-sr-breadcrumb').scrollIntoView({block:'start'});root.querySelector('[data-all-collections]').focus({preventScroll:true})}));root.querySelector('[data-all-collections]').addEventListener('click',()=>{const previous=location.hash.slice(1);history.pushState(null,'','#collections');root.dataset.view='collections';filterRooms('all');root.querySelector('.ap-sr-collections').scrollIntoView({block:'start'});const card=root.querySelector('[data-collection="'+previous+'"]');if(card)card.focus({preventScroll:true})});tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab.dataset.roomTab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(index+1)%tabs.length;if(e.key==='ArrowLeft')n=(index+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n].dataset.roomTab,true)}})});root.querySelectorAll('[data-enter]').forEach(b=>b.addEventListener('click',()=>{select(b.dataset.enter);root.querySelector('.ap-sr-tabs').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'})}));root.querySelectorAll('[data-enlarge]').forEach(b=>b.addEventListener('click',()=>{const d=root.querySelector('#ap-zoom-'+b.dataset.enlarge);d.showModal()}));root.querySelectorAll('dialog').forEach(d=>{d.querySelector('[data-close]').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d)d.close()})});root.querySelectorAll('[data-share-room]').forEach(b=>b.addEventListener('click',async()=>{const link=new URL(location.href);link.hash=b.dataset.shareRoom;const status=b.parentElement.querySelector('.ap-sr-share-status');try{await navigator.clipboard.writeText(link.href);status.textContent=b.dataset.copied}catch{status.textContent=b.dataset.copyFallback+': '+link.href}}));const signs=root.querySelector('[data-zodiac-select]');if(signs)signs.addEventListener('change',()=>{if(signs.value)root.querySelector('[data-zodiac-link]').href=signs.value})}
document.querySelectorAll('.ap-showroom').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ap-showroom').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  if (!document.documentElement.hasAttribute('data-aaronya-filter-shortcuts')) {
    document.documentElement.setAttribute('data-aaronya-filter-shortcuts', '');
    document.addEventListener('click', (event) => {
      const shortcut = event.target.closest('[data-aaronya-filter-shortcut]');
      if (!shortcut) return;

      const target = shortcut.dataset.aaronyaFilterShortcut;
      window.setTimeout(() => {
        const drawer = document.querySelector('#filters-drawer');
        if (!drawer) return;

        const detailsGroups = Array.from(drawer.querySelectorAll('details'));
        if (target !== 'all') {
          detailsGroups.forEach((details) => {
            details.open = false;
          });
        }

        const drawerScroller = drawer.querySelector('.facets-drawer__filters');
        if (drawerScroller) drawerScroller.scrollTop = 0;

        if (target === 'all') {
          detailsGroups.forEach((details) => {
            const label = details.querySelector('summary')?.textContent.trim().toLowerCase() || '';
            details.open =
              details.classList.contains('aaronya-mobile-browse__panel') ||
              label.startsWith('orientation');
          });
          const drawerHeading = drawer.querySelector('#filters-drawer-heading');
          drawerHeading?.focus();
          return;
        }

        if (target === 'sort') {
          const sortSummary = Array.from(drawer.querySelectorAll('summary')).find((item) =>
            item.textContent.trim().toLowerCase().startsWith('sort')
          );
          const sortDetails = sortSummary?.closest('details');
          if (sortDetails) sortDetails.open = true;
          sortSummary?.focus();
          sortSummary?.scrollIntoView({ block: 'start' });
          return;
        }

        const summaries = Array.from(drawer.querySelectorAll('summary'));
        const summary = summaries.find((item) => item.textContent.trim().toLowerCase().startsWith(target));
        if (!summary) return;

        const details = summary.closest('details');
        if (details) details.open = true;
        summary.focus();
        summary.scrollIntoView({ block: 'center' });
      }, 180);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
